/* eslint-disable consistent-return */
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

const joinRules = (rules) => (value, data) => rules.map(
	(rule) => rule(value, data)
).filter((error) => !!error)[0];

export function createValidator(rules) {
	return (data = {}) => {
		const errors = {};
		Object.keys(rules).forEach((key) => {
			const fieldRules = joinRules(rules[key]);
			const error = fieldRules(data[key], data);
			if (error) {
				errors[key] = error;
			}
		});
		return errors;
	};
}

export function required(value) {
	if ((isNil(value) || value.trim().length === 0)) {
		return 'This field is required';
	}
}

export function fileRequired(value) {
	if (!value || isNil(value) || value.length === 0) {
		return 'Please provide a file';
	}
}

export function email(value) {
	if (!isNil(value) &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value.trim())) {
		return 'Please provide a valid email address';
	}
}

export function phone(value) {
	const formattedPhone = (value || '').replace(/[^0-9]+/gi, '');
	if (!(formattedPhone.length >= 10 && formattedPhone.length < 12)) {
		return 'Please provide a valid phone number';
	}
}

export function minLength(min) {
	return (value) => {
		if (!isEmpty(value) && value.length < min) {
			return `Please enter at least ${min} characters.`;
		}
	};
}

export function maxLength(max) {
	return (value) => {
		if (!isEmpty(value) && value.length > max) {
			return `Please enter no more than ${max} characters.`;
		}
	};
}

export function zipCode(value) {
	if (!!value && !(/^[0-9]{5}$/.test(value))) {
		return 'Please provide a valid ZIP code';
	}
}

export function currency(maximumValue) {
	return (value) => {
		if (!!value && !(/^\$?[0-9]+(\.[0-9]{2})?$/.test(value))) {
			return 'Please provide a valid amount';
		}

		if (maximumValue) {
			const sanitized = parseFloat(value.replace('$', ''));
			if (sanitized > maximumValue) {
				return `Please enter an amount less than $${maximumValue}`;
			}
		}
	};
}
